import { MainModules } from 'common/constants/features';
import { IRole, IRoleAccess } from 'common/interfaces/irole';
import { IUserShift } from 'common/interfaces/ishift';
import { IStore } from 'common/interfaces/istore';
import { SessionActions } from 'reducers/session-reducer';
import { useAppDispatch } from 'setup/store';
import { useAppActions } from './app-actions';
import { IBrand } from 'common/interfaces/ibrand';
import { StoreActions } from 'reducers/store-reducer';
import { updateUserDataInHttpHeader } from 'services/config';
import { persistSelectedBrandId } from 'services/db-service';
import UILogger from 'common/utils/logger';
import { getDayReportFields, getRoyaltyConfigs } from 'services/app-service';
import { SnackbarType } from 'common/interfaces';

export const useSessionActions = () => {
  const dispatch = useAppDispatch();
  const { showSnackBar } = useAppActions();

  const setLoading = async (isLoading: boolean) => {
    dispatch(SessionActions.setLoading(isLoading));
  };

  const setSelectedBrand = (brand: IBrand | undefined) => {
    dispatch(SessionActions.resetState());
    dispatch(SessionActions.setSelectedBrand(brand));
    dispatch(StoreActions.resetContext());
    updateUserDataInHttpHeader(brand?.id || 0);
    persistSelectedBrandId(brand?.id || 0);
    loadDayReportConfigs();
  };

  const setSelectedStore = (store: IStore | undefined) => {
    dispatch(SessionActions.setSelectedStore(store));
  };

  const setSelectedShift = (shift: IUserShift | undefined) => {
    dispatch(SessionActions.setSelectedShift(shift));
  };
  const setAllowedFeatures = (features: MainModules[] | string[] | undefined) => {
    dispatch(SessionActions.setAllowedFeatures(features as MainModules[]));
  };

  const setFeatureList = (accessList: IRoleAccess[] | undefined) => {
    dispatch(SessionActions.setAccessList(accessList));
  };

  const setRoleAccessData = (roleData: IRole | undefined) => {
    setAllowedFeatures(roleData?.allowedModules);
    setFeatureList(roleData?.accessList);
    console.log('setRoleAccessData: accessList', roleData?.accessList);
  };

  const loadDayReportConfigs = async () => {
    UILogger.log('loading day report configs:');
    const fieldResp = await getDayReportFields();
    if (fieldResp?.status?.success) {
      dispatch(SessionActions.setDayReportFields(fieldResp.data));
    } else {
      showSnackBar(SnackbarType.ERROR, 'Could not load configurations for day reports. Please reload the app.');
    }
  };

  const loadRoyaltyConfigs = async () => {
    UILogger.log('loading royalty configs:');
    const fieldResp = await getRoyaltyConfigs();
    if (fieldResp?.status?.success) {
      dispatch(SessionActions.setRoyaltyConfig(fieldResp.data));
      return true;
    } else {
      showSnackBar(SnackbarType.ERROR, 'Could not load configurations for day reports. Please reload the app.');
    }
    return false;
  };

  return {
    setLoading,
    setSelectedBrand,
    setSelectedStore,
    setSelectedShift,
    setAllowedFeatures,
    setFeatureList,
    setRoleAccessData,
    loadDayReportConfigs,
    loadRoyaltyConfigs,
  };
};
